import React from "react";
import Helmet from "react-helmet";
import { Link } from "@reach/router";

import Navigation from "../../components/WaveNavigation/";
import PageHeader from "../../components/PageHeader";
import {
  Schedule,
  Panel,
  Line,
  Trip,
  Note,
  SpecialSchedule,
  Legend,
  LegendItem,
  StarItem,
  CircleItem,
  DiamondItem,
  Alert,
} from "../../components/Schedule";
import Amenities from "../../utils/amenities";
import PassengerFreightPolicy from "../../components/PassengerFreightPolicy";
import FreightRestrictions from "../../components/FreightRestrictions";
import NewSchedule from "../../components/NewSchedule";
import NotAvailablePage from "../../components/NotAvailablePage";
import ServiceNotice from "../../components/ServiceNotice";
import NoSchedulesAfter from "../../components/NoSchedulesAfter";

const beach = "Seaview";

export default () => (
  <div>
    <Helmet
      title="Fire Island Ferries | Seaview Schedule"
      meta={[
        {
          name: "description",
          content:
            "Even though it’s only a short distance from Manhattan, Fire Island is a world away from the hustle and bustle of city life. Boasting 32 miles of pristine beaches, Fire Island offers visitors an escape from mainland pressures with beautiful Atlantic Ocean beaches, calming views of the Great South Bay, and access to peaceful wilderness.",
        },
        {
          name: "keywords",
          content: "Fire Island, New York, Long Island, Ferries, Water Taxi",
        },
      ]}
    />
    <Navigation />
    <div className="container p-0">
      <PageHeader beach="Seaview">
        <h2>Schedules</h2>
        <h1>Seaview</h1>

        <div className="d-print-none">
          <p>Amenities</p>
          <div className="amenities">
            {Amenities.byBeach("Seaview").map((item) => (
              <i
                key={item.text}
                className={`icon-${item.icon}`}
                title={item.text}
              />
            ))}
          </div>
          <div>
            <Link className="btn btn-outline-light" to="/communities/seaview">
              Information
            </Link>
            &nbsp;&nbsp;
            <Link className="btn btn-outline-light" to="/directory">
              Directory
            </Link>
          </div>
        </div>
      </PageHeader>
    </div>

    {/* <NotAvailablePage beach={beach} /> */}
    {/* <NewSchedule /> */}
    <NoSchedulesAfter endDate="November 8th" beach={beach} />
    <Schedule
      beach={beach}
      season="Fall Schedule"
      year="2026"
      start="October 13"
      end="November 8"
      download="https://fimedia.s3.us-east-1.amazonaws.com/13OCT26AllTerminals-WEBv2-15OCT26.pdf"
    >
      <Panel
        title="Friday-Sunday"
        beach={beach}
        note3="USE MAIN TERMINAL FOR ALL TRIPS"
      >
        <Line>
          <Trip BS time="10:10am" />
          <Note />
          <Trip FI time="10:50am" />
        </Line>
        <Line>
          <Trip BS time="12:30pm" />
          <Note />
          <Trip FI time="1:10pm" />
        </Line>
        <Line>
          <Trip BS time="3:30pm" />
          <Note />
          <Trip FI time="4:10pm" />
        </Line>
        <Line>
          <Trip BS time="5:35pm" />
          <Note leftArrow rightArrow text="Fri. & Sun. Only, Last Trip 10/25" />
          <Trip FI time="6:15pm" />
        </Line>
        <Line>
          <Trip BS time="7:30pm" />
          <Note leftArrow text="Fri. Only, Last Trip 10/23" />
          <Trip FI time="" />
        </Line>
      </Panel>
    </Schedule>

    <div className="container mb-5 d-print-none">
      <ServiceNotice />
      <PassengerFreightPolicy />
      <FreightRestrictions />
    </div>
  </div>
);
